import styles from './ProgressBar.module.css';

export type ProgressBarProps = {
  /** 0–100+ (acima de 100 satura a largura em 100% mas muda a cor nos tons auto) */
  percentual: number;
  tom?: 'auto-despesa' | 'auto-receita' | 'primario';
  cor?: string;
};

const corPorTom = (tom: 'auto-despesa' | 'auto-receita' | 'primario', percentual: number): string => {
  if (tom === 'auto-despesa') {
    if (percentual > 100) return 'var(--error)';
    if (percentual >= 80) return 'var(--warning)';
    return 'var(--primary)';
  }
  if (tom === 'auto-receita') {
    return percentual >= 100 ? 'var(--success)' : 'var(--primary)';
  }
  return 'var(--primary)';
};

export default function ProgressBar({ percentual, tom = 'primario', cor }: ProgressBarProps) {
  const largura = Math.min(Math.max(percentual, 0), 100);
  const corFinal = cor ?? corPorTom(tom, percentual);

  return (
    <div
      className={styles.trilha}
      role="progressbar"
      aria-valuenow={Math.round(percentual)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className={styles.preenchimento} style={{ width: `${largura}%`, background: corFinal }} />
    </div>
  );
}
